import React, { useEffect, useState } from 'react';
import { Modal } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import classes from './ImageEnlargement.module.css';

export default function ImageEnlargement({ children, enabled, src, srcSet, alt, fill = false, style }) {
  const [opened, setOpened] = useState(false);
  useEffect(() => setOpened(false), [src]);
  const mobile = useMediaQuery('(max-width: 48em)');
  if (!enabled || !src) return children;

  return (
    <div className={fill ? classes.fillFrame : classes.frame} style={style}>
      {children}
      <button
        type="button"
        className={classes.open}
        aria-label={alt ? `Agrandir : ${alt}` : 'Agrandir l’image'}
        onClick={() => setOpened(true)}
      />
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={alt || 'Image agrandie'}
        fullScreen={mobile}
        size="90vw"
        centered
        closeButtonProps={{ 'aria-label': 'Fermer l’image' }}
      >
        <img src={src} srcSet={srcSet || undefined} sizes="90vw" alt={alt || ''} className={classes.image} />
      </Modal>
    </div>
  );
}
